/**
 * The signed DEC contract sheet, a rounded outline (no fill, no folded corner), a thick
 * border, the DEC lettermark and a signature, all in `currentColor` so the caller sets the
 * colour (and can animate it). The companies-solution hero (`PlantContract`) and the
 * producer "Come funziona" closing step both draw the same brand-on-the-contract mark.
 *
 * The DEC lettermark, D E C, no ENERGY wordmark, is lifted from the companies hero
 * contract sheet (`HeroTurbine`, rebuilt from the shipped vector outlines). Drawn into the
 * document at `1 glyph-unit → DEC_S`, the mark 455 units high.
 */
import type { SVGProps } from "react";

import { DecGlyphs } from "./DecMark";

/**
 * Placement props, so the mark can also be nested straight into another `<svg>`. `weight`
 * scales every stroke (1 = the default line), for a bolder mark at icon size.
 */
type DecContractProps = { className?: string; weight?: number } & Pick<SVGProps<SVGSVGElement>, "x" | "y" | "width" | "height" | "style">;

export function DecContract({ className = "", weight = 1, ...at }: DecContractProps) {
  return (
    <svg viewBox="0 0 100 108" className={`block ${className}`} aria-hidden="true" {...at}>
      <rect x="15" y="8" width="70" height="92" rx="12" fill="none" stroke="currentColor" strokeWidth={5 * weight} strokeLinejoin="round" />
      <g stroke="currentColor" strokeWidth={3.2 * weight} strokeLinecap="round" opacity={0.5}>
        <path d="M28 23H72" />
        <path d="M28 31H60" />
      </g>
      <g fill="currentColor" transform="translate(23 42) scale(0.0428)">
        <DecGlyphs />
      </g>
      <path d="M32 82c6-9 10-9 13 0s7 7 11 0 7-9 11 0" fill="none" stroke="currentColor" strokeWidth={3.5 * weight} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
